module.exports = __webpack_public_path__ + "img/cameriere-comico.5c66f772.jpg";